import React from 'react';
import { Container } from '@mui/material';
import LessonAssignmentStepOne from './components/StepOne';
import LessonAssignmentStepTwo from './components/StepTwo';
import LessonAssignmentStepThree from './components/StepThree';
import useLessonAssignment from 'state/providers/LessonAssignmentProvider';
import Stepper from 'components/@common/Stepper';
import { LessonAssignmentStepper } from './components/LessonAssignmentStepper';
import { useSelector } from 'react-redux';
import { AppStoreState } from 'types';
import { translate } from 'translations/translator';
import L from 'translations/variants/lessonAssignment';

const getTranslation = (key: L) => translate('lessonAssignment', key);
const LessonAssignment: React.FC = () => {
  const [{ stepperState }] = useLessonAssignment();
  const currentWorkbook: any = useSelector(({ app }: AppStoreState) => app?.currentWorkbook);

  const steps = [
    {
      label: getTranslation(L.addLessonsAndActivities),
      component: <LessonAssignmentStepOne />
    },
    {
      label: getTranslation(L.addClassesAndStudents),
      component: <LessonAssignmentStepTwo />
    },
    {
      label: getTranslation(L.reviewAndAssign),
      component: <LessonAssignmentStepThree />
    }
  ];

  return (
    <Container
      style={{
        display: 'flex',
        flex: 1,
        flexDirection: 'column',
        backgroundColor: currentWorkbook?.secondaryColor || '#83B8E8',
        maxWidth: '1820px',
        minHeight: '100%',
        padding: 0
      }}
    >
      <Stepper
        steps={steps}
        activeStep={stepperState.activeStep}
        completedSteps={stepperState.completedSteps}
        StepIconComponent={LessonAssignmentStepper}
      />
    </Container>
  );
};

export default LessonAssignment;
